import React, { useEffect, useState } from "react";
import { TutorialsWrapper } from "./Styled";
import Sidebar from "../../components/sidebar/Sidebar";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  SpanStyled,
  TextStyled,
} from "../../components/Styled/Elements";
import SecondaryHeader from "../../components/header/SecondaryHeader";

const Tutorials = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const [sidebarStatus, setSidebarStatus] = useState(false);
  const [tutorialsData, setTutorialsData] = useState([]);
  const [selectedTutorial, setSelectedTutorial] = useState(null);
  const [showFullDesc, setShowFullDesc] = useState(false);

  const DESCRIPTION_LIMIT = 30;

  // Bulletproof extraction utility matching backend and workshop functionality
  const extractYoutubeId = (url) => {
    if (!url) return null;
    const match = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
    return match ? match[1] : null;
  };

  const getTruncatedDescription = (desc) => {
    const words = desc?.split(" ");
    if (words?.length <= DESCRIPTION_LIMIT) return desc;
    return words?.slice(0, DESCRIPTION_LIMIT)?.join(" ") + "...";
  };

  const fetchTutorialsData = async () => {
    const url = `${API_URL}/guideline-videos`;
    try {
      const response = await fetch(url, {
        headers: {
          "X-localization": language,
        },
      });
      const data = await response.json();

      if (response?.ok) {
        setTutorialsData(data?.data);
        if (data?.data?.length > 0) {
          setSelectedTutorial(data.data[0]);
        }
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    fetchTutorialsData();
  }, [language]);

  // Extract video ID safely for the active frame context
  const activeVideoId = selectedTutorial ? extractYoutubeId(selectedTutorial.attachment) : null;

  return (
    <TutorialsWrapper className="d-flex">
      <SecondaryHeader
        sidebarStatus={sidebarStatus}
        setSidebarStatus={setSidebarStatus}
      />
      <Sidebar
        data={tutorialsData}
        selectedTutorial={selectedTutorial}
        onSelect={setSelectedTutorial}
        sidebarStatus={sidebarStatus}
        setSidebarStatus={setSidebarStatus}
      />

      <Box className="flex-grow-1 custom-scroll content-main center-main">
        <Box className="pg-title py-3 px-4">
          <HeadingStyled size="18px" color="var(--text)" weight="bold">
            {t("tutorial_videos")}
          </HeadingStyled>
        </Box>
        <Box className="p-3">
          {selectedTutorial && (
            <Box className=" content-box py-3 px-4">
              <HeadingStyled size="36px" color="var(--text)">
                {selectedTutorial.title}
              </HeadingStyled>
              <Box className="pb-3">
                <SpanStyled>
                  {selectedTutorial?.description && showFullDesc
                    ? selectedTutorial?.description
                    : selectedTutorial?.description && getTruncatedDescription(selectedTutorial?.description)}
                  {selectedTutorial?.description && selectedTutorial?.description?.split(" ")?.length >
                    DESCRIPTION_LIMIT && (
                    <ButtonStyled
                      width="auto"
                      className="py-0 px-2"
                      color="var(--themeColor)"
                      onClick={() => setShowFullDesc((prev) => !prev)}
                    >
                      {showFullDesc ? t("show_less") : t("show_more")}
                    </ButtonStyled>
                  )}
                </SpanStyled>
              </Box>

              {/* Embed YouTube video with Privacy-Enhanced domain fix */}
              <Box className="ratio ratio-16x9">
                {activeVideoId ? (
                  <iframe
                    src={`https://www.youtube-nocookie.com/embed/${activeVideoId}?rel=0&modestbranding=1`}
                    title={selectedTutorial.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    className="tutorial-vid"
                  ></iframe>
                ) : (
                  <Box className="d-flex align-items-center justify-content-center text-muted border rounded style-vid-fallback">
                    {t("invalid_video_link")}
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </TutorialsWrapper>
  );
};

export default Tutorials;